import { useFinanceiroObrasListaView } from "./use-financeiro-obras-lista-view";
import { FinanceiroObrasListaView } from "./view-financeiro-obras-lista-view";
import type { FinanceiroObrasListaViewProps } from "./types-financeiro-obras-lista-view";

/** Liga o ViewModel à View da Lista. */
export function FinanceiroObrasLista(props: FinanceiroObrasListaViewProps) {
  const vm = useFinanceiroObrasListaView(props);
  return <FinanceiroObrasListaView {...vm} />;
}

export type * from "./types-financeiro-obras-lista-view";
